import React from 'react';
import { trim } from 'lodash';

import './RangeInput.scss';

const RangeInput = ({
  qtySelected,
  decreaseQty,
  updateQty,
  handleBlur,
  increaseQty,
  maxQty,
  minQty,
}) => {
  return (
    <div className='prd-qty-selection'>
      <button
        className={trim(
          `prd-qty-button ${
            qtySelected <= minQty || qtySelected === '' ? 'inactive' : ''
          }`,
        )}
        onClick={() => {
          if (qtySelected > minQty && qtySelected !== '') {
            decreaseQty();
          }
        }}
      >
        &ndash;
      </button>
      <input
        className='prd-qty-input'
        type='number'
        pattern='[0-9]*'
        inputMode='numeric'
        name='qty'
        id='qty'
        value={qtySelected}
        onChange={updateQty}
        onBlur={handleBlur}
      />
      <button
        className={trim(
          `prd-qty-button ${qtySelected >= maxQty ? 'inactive' : ''}`,
        )}
        onClick={() => {
          if (qtySelected < maxQty) {
            increaseQty();
          }
        }}
      >
        +
      </button>
    </div>
  );
};

export default RangeInput;
